import React, { useRef, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { user as getUser } from '~data/selectors/user'

import Contextmenu from './menu'
import { Button, Avatar, Icon } from '~ui'

const UserProfileButton = React.memo(function UserProfileButton({
    children,
    ...etc
}) {
    const user = useSelector(state => getUser(state))
    const pin = useRef(null)
    const [menu, setMenu] = useState(false)

    const onProfileClick = useCallback(e => {
        e.preventDefault()
        setMenu(prev => !prev)
    }, [])

    const onProfileClose = useCallback(() => setMenu(false), [])

    return (
        <>
            <Button
                variant='ghost'
                {...etc}
                ref={pin}
                onMouseDown={onProfileClick}>
                <Avatar src={user.avatar} />
                {children && children(user)}
                <Icon name='arrow' size='micro' />
            </Button>

            {menu && <Contextmenu pin={pin} onClose={onProfileClose} />}
        </>
    )
})

export default UserProfileButton
